import React from "react";

export const LazyImageIntersectionObserverContext = React.createContext(null);
